var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('widget-common-props',{attrs:{"field":_vm.field},on:{"changeProp":_vm.changeProp}}),_c('b-form-group',{attrs:{"label-cols":"3","label":"Widgets"}},[_c('f-child-fields',{attrs:{"fields":_vm.field.fields},on:{"change":_vm.on_changed_fields,"select":_vm.on_select}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }